import React from 'react';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';

import css from './shopify-msd-saving.less';

const ShopifyMsdSaving = ({ savingsAmount }) => (
  <div className={css.shopifyMsdSaving}>
    {I18n.t('shopify.orders.createBookingPage.msdSaving', {
      amount: savingsAmount,
    })}
  </div>
);

ShopifyMsdSaving.propTypes = {
  savingsAmount: PropTypes.string,
};

ShopifyMsdSaving.defaultProps = {
  savingsAmount: '',
};

export default ShopifyMsdSaving;
